import type { Theme } from './types.js'

/** Graphite — Indigo sur fond blanc pur. SaaS premium, proche Notion/Linear. */
export const graphite: Theme = {
  id: 'graphite',
  displayName: 'Graphite',
  description: 'Indigo sur blanc pur, style SaaS premium',
  preview: { primary: '#6366f1', sidebar: '#111318', accent: '#0d9488' },
  tokens: {
    colors: {
      primary: '#6366f1',
      primaryHover: '#4f46e5',
      primaryLight: '#eef2ff',
      secondary: '#0d9488',
      accent: '#0d9488',
      surface: '#ffffff',
      surfaceRaised: '#fafafa',
      background: '#ffffff',
      border: '#e4e4e7',
      borderSubtle: '#f4f4f5',
      textPrimary: '#09090b',
      textSecondary: '#52525b',
      textDisabled: '#a1a1aa',
      textInverse: '#ffffff',
      success: '#16a34a',
      successLight: '#f0fdf4',
      warning: '#ca8a04',
      warningLight: '#fefce8',
      error: '#dc2626',
      errorLight: '#fef2f2',
      info: '#6366f1',
      infoLight: '#eef2ff',
      sidebarBg: '#111318',
      sidebarText: '#a1a1aa',
      sidebarHover: 'rgba(255,255,255,0.06)',
    },
  },
  darkMode: {
    colors: {
      surface: '#18181b',
      surfaceRaised: '#09090b',
      background: '#09090b',
      border: '#27272a',
      textPrimary: '#fafafa',
      textSecondary: '#a1a1aa',
      sidebarBg: '#09090b',
    },
  },
}
